export default __webpack_public_path__ + "static/font-439f7f937e0cfd351918620d96fac6cb.woff2";